/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Modal } from 'react-bootstrap';


const ModalBanner = ({
  label = '',  
  showModal,
  onCloseModal,
  objBanners ={}
}) => {
  console.log('asas',objBanners)
  return (
    <React.Fragment>
      <Modal
        show={showModal}
        onHide={onCloseModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <h2 className="text-mex">{label}</h2>
        </Modal.Header>
        <Modal.Body>          
            <img src={objBanners?.general} style={{width:"100%"}} />          
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={onCloseModal}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ModalBanner;
